<template>
  <RichText
    class="select-all"
    :class="{
      'punchline max-w-[540px]': isHero,
      'heading-1 max-w-[440px]': !isHero,
    }"
    :node-renderers-overrides="renderParagraphAsHeading"
    :rich-text="title"
    style-variant="none"
  />
</template>

<script setup lang="ts">
import { h } from 'vue'

import type { RichText as RichTextType } from '@backmarket/http-api/src/api-specs-content/models/rich-text'
import { tw } from '@backmarket/utils/string/tw'
import type { NodeRendererMap } from 'contentful-rich-text-vue-renderer'

import RichText from '../RichText/RichText.vue'
import { findTitleId } from '../RichText/RichTextVueParser.utils'

const {
  title,
  isHero,
  tagType = 'h2',
} = defineProps<{
  title: RichTextType
  isHero: boolean
  tagType: 'h2' | 'h3'
}>()

const titleId = findTitleId(title)

// render the title as a h2 or h3 tag
const renderParagraphAsHeading: NodeRendererMap = {
  paragraph: (node, key, next) => {
    return h(
      tagType,
      { key, class: tw`empty:hidden`, id: titleId },
      next(node.content, key, next),
    )
  },
}
</script>
